export default __webpack_public_path__ + "static/media/provider_14.edd781f0.png";